import { createRoute, redirect } from '@tanstack/react-router';
import { Route as appRoute } from '../../app.js';
import { useAuthStore } from '../../../lib/auth.js';
import { canSeeCatalogueOverview } from '../../../lib/capabilities.js';
import { ConsultantPricingPage } from '../pricing.js';

export const Route = createRoute({
  getParentRoute: () => appRoute,
  path: '/oversight/catalogue',
  // view_pricing, and NOT a consultant (who has their own /app/pricing). The
  // server's view_pricing capability stays the real gate — a revoked owner gets a
  // 403 surfaced through the reused screen's error state.
  beforeLoad: () => {
    if (!canSeeCatalogueOverview(useAuthStore.getState().user)) throw redirect({ to: '/app' });
  },
  component: CatalogueOverviewPage,
});

/**
 * Read-only catalogue/pricing overview for owner/accounts (Brief OA). It REUSES
 * the consultant read-only pricing screen VERBATIM — same net-fee-only
 * view_pricing endpoint, same table — behind the oversight gate. There is no new
 * pricing API and, deliberately, no commission reader: even though owner/accounts
 * hold view_commission, this screen calls only the net-fee read.
 */
export function CatalogueOverviewPage() {
  return <ConsultantPricingPage />;
}
